import { CompensationEmployeeMapUI } from 'modules/employees/pages/BulkFixContractsPage/types'

interface SetKeepExistingCompensationsAction {
  type: 'setKeepExistingCompensations'
  payload: boolean
}
export function setKeepExistingCompensationAction(
  keep: boolean
): SetKeepExistingCompensationsAction {
  return {
    type: 'setKeepExistingCompensations',
    payload: keep,
  }
}

interface AddCompensationAction {
  type: 'addCompensation'
  payload: CompensationEmployeeMapUI
}
export function addCompensationAction(
  newCompensation: CompensationEmployeeMapUI
): AddCompensationAction {
  return {
    type: 'addCompensation',
    payload: newCompensation,
  }
}

interface UpdateCompensationAction {
  type: 'updateCompensation'
  payload: CompensationEmployeeMapUI
  /**
   * The array index for the compensation
   */
  meta: number
}

interface RemoveCompensationAction {
  type: 'removeCompensation'
  meta: number
}
export function removeCompensationAction(index: number): RemoveCompensationAction {
  return {
    type: 'removeCompensation',
    meta: index,
  }
}

export type BulkFixContractsAction =
  | SetKeepExistingCompensationsAction
  | AddCompensationAction
  | UpdateCompensationAction
  | RemoveCompensationAction
